"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  id: 1,
  src: "https://sara-michael-wedding.10web.cloud/wp-content/uploads/2026/04/6B8A8358-scaled.jpeg?v=7h20vsycjrx",
  alt: "Sunlight through Roman pines at Villa Borghese",
  caption: "Piazza d'Italia, New Orleans",
  aspect: "aspect-[3/4]"
}, {
  id: 2,
  src: "https://sara-michael-wedding.10web.cloud/wp-content/uploads/2026/04/6B8A8570-scaled.jpeg?v=kxza8ktrnbp",
  alt: "Strolling through the cobblestone streets of Trastevere",
  caption: "Lafayette Square, New Orleans",
  aspect: "aspect-[16/9]"
}, {
  id: 3,
  src: "https://sara-michael-wedding.10web.cloud/wp-content/uploads/2026/04/6B8A8409-scaled.jpeg?v=cayka5cxce8",
  alt: "A quiet moment by a hidden Roman fountain",
  caption: "Piazza d'Italia, New Orleans",
  aspect: "aspect-square"
}, {
  id: 4,
  src: "https://sara-michael-wedding.10web.cloud/wp-content/uploads/2026/04/6B8A8817-scaled.jpeg?v=8vyxs0ipof",
  alt: "Ancient Roman arches framing the sunset",
  caption: "Piazza d'Italia, New Orleans",
  aspect: "aspect-[4/3]"
}, {
  id: 5,
  src: "https://sara-michael-wedding.10web.cloud/wp-content/uploads/2026/04/6B8A8619-scaled.jpeg?v=4irt53yrydn",
  alt: "Toasting to the future on a Roman rooftop terrace",
  caption: "Lafayette Square, New Orleans",
  aspect: "aspect-[3/4]"
}, {
  id: 6,
  src: "https://sara-michael-wedding.10web.cloud/wp-content/uploads/2026/04/6B8A8862-scaled.jpeg?v=zxjhztjghdg",
  alt: "Walking along the banks of the Tiber River at dusk",
  caption: "Piazza d'Italia, New Orleans",
  aspect: "aspect-[4/3]"
}];
export default function TheRhythmOfCaparica() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: galleryRef,
    isVisible: isGalleryVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return <section data-section-id="128086" id="capturing-the-romance" className="bg-background py-24 lg:py-32 overflow-hidden text-foreground">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={headerRef} className={`mb-16 max-w-2xl transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground mb-6 tracking-tighter">
            She Said Yes!
          </h2>
          <p className="font-sans text-muted-foreground text-lg leading-relaxed max-w-xl">
            Scenes from our proposal in New Orleans
          </p>
        </div>

        <div ref={galleryRef} className={`columns-1 md:columns-2 lg:columns-3 gap-10 space-y-10 transition-all duration-1000 delay-200 ease-out ${isGalleryVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className="break-inside-avoid relative group overflow-hidden rounded-tl-[3rem] bg-muted/30 shadow-sm">
              <div className={`relative w-full overflow-hidden ${item.aspect}`}>
                <img src={item.src} alt={item.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
              </div>
              
              {}
              <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out pointer-events-none" />
              
              {}
              <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-all duration-500 delay-100 ease-out translate-y-2 group-hover:translate-y-0 pointer-events-none">
                <p className="font-sans text-[10px] uppercase font-bold text-primary-foreground tracking-[0.2em] bg-primary/90 px-4 py-2 backdrop-blur-sm shadow-md">
                  View — {item.caption}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}